import ListContainer from '../../lib/ListContainer'
import Experiment from '../containers/Experiment';

async function listExperimentsByFiscalYear(fiscal_year: number) {
  const path = '/api/asebi/fiscal_years/' + fiscal_year.toString();
  const resp = await fetch(path);
  const json = await resp.json();

  return json.map((data: any) => {
    const e = new Experiment();
    e.load(data);
    return e;
  });
}

export default listExperimentsByFiscalYear;
